import { Button, EButtonVariant } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { DialogContent } from "components/DialogContent/DialogContent";
import { SemiBoldText } from "components/SemiBoldText/SemiBoldText";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";

export const ModalDeleteGroup = (): JSX.Element => (
  <DialogContent className="flex items-center flex-col">
    <SemiBoldText className="flex justify-center items-center w-3/4 text-center">
      Вы действительно хотите удалить группу?
    </SemiBoldText>
    <VerticalSpace size={36} />
    <div className="flex flex-row">
      <Button variant={EButtonVariant.SECONDARY}>Удалить</Button>
      <HorizontalSpace size={5} />
      <Button variant={EButtonVariant.TERTIARY}>Нет</Button>
    </div>
  </DialogContent>
);
